import { get } from '../../helpers/utils/http-client';
import { CONFIGS_ENDPOINT } from '../../consts/api-endpoints';

export async function getConfig(type, configName, accessKey) {
  try {
    const { response, status } = await get(
      `${CONFIGS_ENDPOINT}/${type}/${configName}`,
      {},
      { Authorization: accessKey }
    );
    if (status !== 200) {
      return {};
    }
    return response;
  } catch (err) {
    console.debug('getConfig failed cause', err.message, err.code);
    return {};
  }
}
